export enum testTypes {
    FETCH_TESTS_REQUEST = 'FETCH_TESTS_REQUEST',
    FETCH_TEST_BY_ID = 'FETCH_TEST_BY_ID',
    CREATE_TEST_REQUEST = 'CREATE_TEST_REQUEST',
    EDIT_TEST_REQUEST = 'EDIT_TEST_REQUEST',
    DELETE_TEST_REQUEST = 'DELETE_TEST_REQUEST',
    SET_TESTS = 'SET_TESTS',
    SET_TEST = 'SET_TEST',
}
